import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PadraoSelectCrud } from 'app/interfaces/compartilhados/Inputs';

@Component({
  selector: 'app-select-padrao-crud',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './select-padrao-crud.component.html',
  styleUrl: './select-padrao-crud.component.css'
})
export class SelectPadraoCrudComponent {
  @Input() public dadosSelect!: PadraoSelectCrud; 
  @Input() public alt: string = "";

  @Output() eventoSelect = new EventEmitter<string | null>();
  
  public pegarValorAtual(event:Event) {
    const valorSelecionado: string = (event.target as HTMLSelectElement).value;
    this.emitirValorSelecionado(valorSelecionado);
  }

  public emitirValorSelecionado(valorSelecionado: string) { 
    this.eventoSelect.emit(valorSelecionado == 'null' ? null : valorSelecionado)
  }
}
